import {
  IconProductEngineer,
  IconProductFavicon,
  IconProductFinance,
  IconProductGrowth,
  IconProductHr,
  IconProductOperations,
  IconProductSales,
} from '@ergeon/icons/react';
import { ClipboardDocumentListIcon, FaceSmileIcon, Squares2X2Icon } from '@ergeon/icons/hero/solid';

export const defaultCategories = [{
  icon: IconProductFavicon,
  nodeKey: '202000389',
  title: 'Company Information',
}, {
  icon: IconProductGrowth,
  nodeKey: '202000391',
  title: 'Growth',
}, {
  icon: IconProductSales,
  nodeKey: '202000392',
  title: 'Sales',
}, {
  icon: IconProductOperations,
  nodeKey: '202000393',
  title: 'Operations',
}, {
  icon: IconProductEngineer,
  nodeKey: '202000394',
  title: 'Engineering',
}, {
  icon: IconProductFinance,
  nodeKey: '202000396',
  title: 'Finance',
}, {
  icon: IconProductHr,
  nodeKey: '202000397',
  title: 'Human Resources',
}, {
  icon: Squares2X2Icon,
  nodeKey: '202102093',
  title: 'Category',
}, {
  icon: ClipboardDocumentListIcon,
  nodeKey: '202102094',
  title: 'Materials',
}, {
  icon: FaceSmileIcon,
  nodeKey: '202102255',
  title: 'Customer Service',
}];
